import Layout from "../../components/layout/Layout";
import "./company.css";

const Company = () =>{
    return(
        <Layout>
            <></>
        </Layout>
    )
} 

export default Company